// @flow strict
import React from 'react'
import styles from './ConsentCheckbox.module.scss'

type Props = {
  name: string,
  text: string,
  required?: boolean,
}

const ConsentCheckbox = ({ name, text, required }: Props) => (
  <div className={styles.wrapper} data-testid="ConsentCheckbox">
    <input id={name} required={required} type="checkbox" />
    <label htmlFor={name} className={styles.text}>
      {text}
    </label>
  </div>
)

export default ConsentCheckbox
